<template functional>
  <div class="topic">
    <div class="topic__card">
      <div class="topic__details">
        <div class="topic__title">{{ props.topicTitle }}</div>
        <p class="topic__detail">
          <span class="topic__lead">Levels:</span>
          <span class="topic__data">{{ props.topicLevelsLength }}</span>
        </p>
        <p class="topic__detail">
          <span class="topic__lead">Video(s):</span>
          <span class="topic__data">{{ props.topicDuration }}</span>
        </p>
      </div>
      <div v-if="props.isUser" class="topic__progress">
        <component
          :is="props.components.RadialProgressBar"
          :diameter="30"
          :strokeWidth="3"
          startColor="#00DC9B"
          :completed-steps="props.topicProgress"
          :total-steps="props.topicLevelsLength"
        ></component>
        <span
          v-if="props.topicProgress === props.topicLevelsLength"
          class="material-icons topic__completed"
          >check</span
        >
        <p class="topic__progress-count">
          {{ props.topicProgress }} / {{ props.topicLevelsLength }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'

export default {
  name: 'Topic',
  props: {
    components: {
      type: Object,
      default() {
        return {
          RadialProgressBar,
        }
      },
    },
    isUser: {
      required: false,
      type: Boolean,
    },
    topicTitle: {
      required: true,
      type: String,
    },
    topicLevelsLength: {
      required: true,
      type: Number,
    },
    topicDuration: {
      required: true,
      type: String,
    },
    topicProgress: {
      required: true,
      type: Number,
    },
  },
}
</script>

<style lang="scss" scoped>
.topic {
  width: 100%;
  margin: 0 0 20px 0;
  @include tablet {
    width: 25%;
    margin: 0;
    @include tablet {
      padding: 0 15px 0 0;
    }
  }
  &__card {
    display: flex;
    padding: 30px;
    background-color: var(--light-gray);
    border-radius: 5px;
    @include tablet {
      min-height: 200px;
    }
  }
  &__title {
    font-size: 22px;
    font-weight: 700;
    color: var(--white);
    margin: 0 0 22px 0;
    max-width: 90%;
    font-family: var(--font-bold);
  }
  &__detail {
    margin: 0;
    padding: 0;
  }
  &__lead {
    color: var(--gray);
    margin: 0 5px 0 0;
    font-size: 16px;
    font-family: var(--font-medium);
  }
  &__data {
    color: var(--white);
    font-size: 16px;
    font-family: var(--font-medium);
  }
  &__progress {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: auto;
    position: relative;
  }
  &__completed {
    position: absolute;
    color: var(--black);
    background-color: var(--green);
    border-radius: 100%;
    font-size: 1.5rem;
    padding: 2px;
  }
  &__progress-count {
    margin: 3px 0 0 3px;
    font-size: 14px;
    color: var(--gray);
    width: 100%;
  }
}
</style>
